import { Component, OnInit ,Input,Output,EventEmitter,SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-userinfo',
  templateUrl: './userinfo.component.html',
  styleUrls: ['./userinfo.component.css']
})
export class UserinfoComponent implements OnInit {
    @Input() data: any;
    @Input() cls: any;
    // @Output() callback: EventEmitter<any> = new EventEmitter();
    power:number = 0;
    uid:string = '';
    height:string = '';
    loading:boolean = false;
    edit:boolean = false;
    showdata:any=[];
    iconPic:string = environment.picfile+'icon-app.png';

    constructor(
        public httpClient: HttpClient,
    ) { }

  ngOnInit(): void {
    this.uid = this.data.uid;
    this.edit = this.data.edit;
    if(typeof(this.data.height)!='undefined'){
        this.height = this.data.height;
    }
    if(typeof(this.data.power)!='undefined'){
        this.power = this.data.power;
    }
  }

  // ngOnChanges(changes: {[propKey: string]: SimpleChanges }) {
   
  // }
  
  init_list(){
    const body = {
        page: 0,count:10,
        search:this.uid,
        sort:'desc',
        gender:-1,
        country:-1,
        order:'id'
    };
    this.httpClient.post<any>("/get_user_list.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.showdata = res.data[0]
      }else{
        this.showdata = false
      }

      console.log('res',res);
    });
  }

  

}
